module.exports = __webpack_public_path__ + "static/media/SS.16beb1de.svg";